import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useSlotProps, ClearSlots } from "../../utils/slots.es.js";
const Slot = forwardRef(function Slot2(props, ref) {
  const { element: Element, slot, ...rest } = props;
  const { children, ...otherProps } = useSlotProps(rest, slot);
  return /* @__PURE__ */ jsx(Element, { ...otherProps, ref, children: /* @__PURE__ */ jsx(ClearSlots, { children }) });
});
export {
  Slot as default
};
//# sourceMappingURL=Slot.es.js.map
